<template>
	<div id="informationPoster">
		<mobileHeader url="informationList"></mobileHeader>
		<div class="info-box">
			<div class="poster-box">
				<img :src="detail.poster_url" alt="" class="poster-img">
                <p class="price" v-if="detail.price">￥{{detail.price}}</p>
				<div v-if="detail.is_contact">
					<vue-qr :text="website+'mobile/informationDetail?id='+id" :size="200" class="qrcode"></vue-qr>
					<div class="input-box">
						<input type="text" v-model="form.name">
						<input type="text" v-model="form.phone">
						<input type="text" v-model="form.company">
					</div>
				</div>
			</div>
			<div class="bottom-txt">
				<p>{{detail.title}}</p>
				<!-- <img src="@/assets/images/share-btn.png" alt="" @click="shareTipsShow=true"> -->
			</div>
		</div>
		<!-- <p class="btn btn2" @click="downloadPoster">保存图片</p> -->
		<p class="btn btn2" @click="downloadPoster">输入信息保存个性化专属图片</p>
		<router-link :to="'/mobile/informationDetail?id='+detail.id" class="btn">查看产品详情</router-link>
		<a :href="detail.mobile_url"><p class="bottom">前往惠普知识树查看更多</p></a>
		<div class="share-tips" v-if="shareTipsShow" @click="shareTipsShow=false"><img src="@/assets/images/share-tips.png" alt=""></div>
	</div>
</template>

<script>
import wxapi from "@/assets/js/wxsdk.js";
export default {
  mounted() {
	  this.id=this.$route.query.id;
	  this.form.url=this.website+'mobile/informationDetail?id='+this.id;
	  // this.form.name=window.localStorage.getItem("name")
	  // this.form.phone=window.localStorage.getItem("phone")
	  // this.form.company=window.localStorage.getItem("company")
	  this.getdetail();
	  wxapi.wxRegister(this.wxRegCallback)
  },
  data() {
    return {
	  id:"",
	  detail:{},
	  form:{
		  name:window.localStorage.getItem("name"),
		  phone:window.localStorage.getItem("phone"),
		  company:window.localStorage.getItem("company"),
		  url:"",
	  },
	  shareTipsShow:false
    }
  },
  components: {
	  
  },
  methods: {
	  wxRegCallback(){
		  wxapi.ShareTimeline({link:this.form.url});
		  wxapi.ShareAppMessage({link:this.form.url});
	  },
	  tabsChange(index){
		  this.tabsSelected=index;
		  this.sales_caseDetailShow=false;
	  },
	  getdetail(txt){
		  var t=this;
		  this.fetchGet(`/api/v1/ent/products/${this.id}/poster`).then((res) => {
			if(res.code==200){
				this.detail=res.data;
			}
		  })
	  },
	  downloadPoster() {
		  var form=this.form;
		  if(this.detail.is_contact==1){
			if(!form.name){
				alert("请填写姓名")
			    return false;
			}
			if(form.name.length>18){
				alert("姓名不能超18个字符")
			    return false;
			}
			if(!(/^1\d{10}$/.test(form.phone))){
			    alert("手机号码有误");
			    return false;
			}
			if(!form.company){
				alert("请填写公司")
			    return false;
			}
			if(form.company.length>18){
				alert("公司不能超18个字符")
			    return false;
			}
		  }
		  window.localStorage.setItem("name",form.name)
		  window.localStorage.setItem("phone",form.phone)
		  window.localStorage.setItem("company",form.company)
		  this.fetchPost(`/api/v1/ent/products/${this.id}/poster`,form).then((res) => {
			if(res.code==200){
				this.detail=res.data;
				var a=document.createElement("a");
				a.href=res.data.url
				a.setAttribute('download', '');
				a.click();
			}
		  })
	  },
  },
}
</script>
<style scoped>
	#informationPoster{padding-bottom: 1.5rem;}
	#informationPoster .info-box{background: #fff;}
	#informationPoster .info-box .poster-box{position: relative;}
	#informationPoster .info-box .poster-box .price{position: absolute;right: 0.49rem;bottom: 2.62rem;text-align: center;font-size: 0.39rem;color: #0096d6;font-weight: 500;line-height: 0.5rem;width: 2.23rem;font-family: "微软雅黑";}
	#informationPoster .info-box .poster-box .qrcode{position: absolute;bottom: 0.9rem;left: 0.65rem;width: 1.36rem;height: 1.36rem;}
	#informationPoster .info-box .poster-box .input-box{position: absolute;bottom: 0.63rem;right: 0.74rem;width: 3.57rem;}
	#informationPoster .info-box .poster-box .input-box input{display: block;margin-top: 0.14rem;font-size: 0.2rem;height: 0.44rem;width: 100%;border: none;background: none;}
	#informationPoster .info-box img{display: block;width: 100%;}
	#informationPoster .info-box .bottom-txt{padding: 0.29rem 0.24rem;display: flex;align-items: center;}
	#informationPoster .info-box .bottom-txt img{width: 1.8rem;height: 0.71rem;flex: 0 0 auto;}
	#informationPoster .info-box .bottom-txt p{font-size: 0.38rem;line-height: 0.45rem;color: #727272;display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;width: 100%;}
	#informationPoster .btn{width: 7rem;height: 0.98rem;line-height: 0.98rem;text-align: center;background: #0096D6;color: #fff;font-size: 0.32rem;margin: 0.4rem auto 0;display: block;}
	#informationPoster .btn2{background: #EA3676;}
	#informationPoster .bottom{background: #0096D6;font-size: 0.31rem;height: 0.9rem;background: #0096D6;color: #FFFFFF;text-align: center;line-height: 0.9rem;position: fixed;bottom: 0;left: 0;width: 100%;}
	.share-tips{position: fixed;width: 100%;height: 100%;left: 0;top: 0;}
	.share-tips img{width: 100%;display: block;}
</style>